// 系统参数编号
export const SystemParamCode = {
  AdminAccount: 'AdminAccount', // 管理员账号
  InternetTitle: 'InternetTitle', // 网站标题
  CompanyName: 'CompanyName', // 公司名称
  InitAccountPassword: 'InitAccountPassword', // 初始账号密码
  HomeMenuName: 'HomeMenuName', // 首页菜单名称
  AuditServiceType:'AuditServiceType', // 服务类型是稽查类型
}